<template>
    <div>
        <v-data-table v-model="selectedItems" :headers="headers" :items="items" :items-per-page="10"
            :options.sync="options" :server-items-length="totalItems" item-key="id"
            :show-select="!showDeletedCategories" :loading="isLoading" :loading-text="$t('loadingPleaseWait')"
            :no-data-text="$t('noCategoriesData')" :footer-props="footerProps" :header-props="headerProps"
            :item-class="getItemClass">
            <template v-slot:item.action="{ item }">
                <div style="width: 50px;">
                    <template v-if="isDeletedCategory(item)">
                        <v-icon small @click="restoreHandler(item)"> restore </v-icon>
                    </template>
                    <template v-else>
                        <v-icon small @click="updateHandler(item.id)"> edit </v-icon>
                        <v-icon small @click="deleteHandler(item)">
                            close
                        </v-icon>
                    </template>
                </div>
            </template>
        </v-data-table>
        <v-snackbar :color="snackColor" dark v-model="snackOpen" top v-if="snackOpen && snackDelete">
            <span class="caption pr-4">{{ confirmationText }}</span>
            <div>
                <v-btn text class="text--main-yellow" @click="confirmationHandler">{{ $t('yes') }}</v-btn>
                <v-btn text icon @click="closeConfirmationSnack">
                    <v-icon color="grey">close</v-icon>
                </v-btn>
            </div>
        </v-snackbar>
    </div>
</template>

<script>
import { CategoriesService } from "../../../services";
import { MixinAppSnack, MixinTableLoadState } from '../../../mixins'
import { EnumAttributeValueDialog, EnumAttributeValueFullscreenDialog } from '../../modals'
import { isCategoryAvailableForDelete, isTopCategory } from "../../../model/utils";

export default {
    name: "CategoriesTable",
    components: { EnumAttributeValueDialog, EnumAttributeValueFullscreenDialog },
    mixins: [MixinAppSnack, MixinTableLoadState],
    props: ['filters'],
    data() {
        return {
            headers: [],
            items: [],
            options: {},
            totalItems: null,
            updatingId: null,
            categoryToDelete: null,
            categoryToRestore: null,
            footerProps: {
                'items-per-page-text': this.$t('rowsPerPage'),
                'items-per-page-all-text': this.$t('all')
            },
            headerProps: {
                sortByText: this.$t('sortBy'),
            }
        }
    },
    computed: {
        selectedItems: {
            get() {
                return this.$store.getters.selectedCategories;
            },
            set(newVal) {
                this.$store.commit('setSelectedCategories', newVal);
            }
        },
        updateTableData() {
            return this.$store.getters.updateCategoriesTable;
        },
        showDeletedCategories() {
            return Boolean(this.filters?.category_deleted);
        },
        deleteText() {
            if (!this.categoryToDelete) return '';

            return `${this.$t('delete')} "${this.categoryToDelete.name}"?`;
        },
        restoreText() {
            if (!this.categoryToRestore) return '';

            return `${this.$t('categoryRestoreConfirmation')} "${this.categoryToRestore.name}"?`;
        },
        confirmationText() {
            return this.categoryToRestore ? this.restoreText : this.deleteText;
        }
    },
    methods: {
        setItems() {
            if (!this.startTableLoading()) return false;

            const params = {
                ...this.options,
                pageType: this.pageType,
                filters: this.filters
            };

            CategoriesService.getCategories(params)
                .then(res => {
                    this.items = res.data.data;
                    this.totalItems = res.data.total;
                })
                .catch(err => {
                    this.emitTableLoadError(err);
                })
                .finally(() => {
                    this.stopTableLoading();
                });
        },
        setTable() {
            CategoriesService.getTableData()
                .then(res => {
                    this.headers = res.data.headers;
                })
                .catch(err => {
                    this.emitTableLoadError(err);
                })
        },
        updateHandler(id) {
            this.$emit('update', id);
        },
        restoreHandler(category) {
            this.resetSnack();
            this.categoryToDelete = null;
            this.categoryToRestore = category;
            this.setDeleteSnack();
            this.openSnack();
        },
        deleteHandler(category) {
            this.resetSnack();
            this.categoryToRestore = null;

            if (isCategoryAvailableForDelete(category)) {
                this.categoryToDelete = category;
                this.setDeleteSnack();
                this.openSnack();
            } else {
                this.categoryToDelete = null;
                this.$emit('restricted');
            }
        },
        closeConfirmationSnack() {
            this.categoryToDelete = null;
            this.categoryToRestore = null;
            this.resetSnack();
        },
        confirmationHandler() {
            if (this.categoryToRestore) {
                this.$emit('restore', this.categoryToRestore.id);
            } else {
                this.$emit('delete', this.categoryToDelete.id);
            }

            this.closeConfirmationSnack();
        },
        getItemClass(item) {
            return isTopCategory(item.lvl) ? 'font-weight-bold orange--text' : '';
        },
        isDeletedCategory(category) {
            return Boolean(category.deletedAt);
        },
    },
    created() {
        this.setTable();
        CategoriesService.setAuth(this.$store.getters.token);
    },
    watch: {
        options: {
            handler() {
                this.setItems();
            },
            deep: true
        },
        filters: {
            handler() {
                this.setItems();
            },
            deep: true
        },
        updateTableData(value) {
            if (value) {
                this.setItems();
                this.$store.commit('setUpdateCategoriesTable', false);
            }
        }
    }
}
</script>
